export const convertFromSecondsReadable = d => {
    d = Number(d);

    if (d === 0) {
        return '0:00';
    }

    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
    return hDisplay + mDisplay + sDisplay; 
};

export const convertFromSeconds = d => {
    d = Number(d);
    var prefix = '';

    if (d === 0) {
        return '0:00';
    }

    const h = Math.floor(d / 3600);

    if (h > 0) {
        prefix = `${h}:`;
        d = d - (h * 3600);
    }

    const m = Math.floor(d / 60);
    const s = Math.floor(d % 3600 % 60);

    const minutes = (h > 0) ? m.toString().padStart(2, '0') : m.toString();
    const seconds = s.toString().padStart(2, '0');

    return `${prefix}${minutes}:${seconds}`;
};

export const convertToSeconds = str => {
    if (typeof str !== 'string' || str == '') {
        return 0;
    }

    const pieces = str.split(":");

    if (pieces.length == 1) {
        return Number(pieces[0]);
    }

    const result = Number(pieces[0]) * 60 + Number(pieces[1]);

    return result;
}
